export enum StepColor {
    WARN = 'pending',
    SUCCESS = 'success',
}

export enum StepType {
    FUTURE = 'future',
    PAST = 'past',
    PRESENT = 'present',
}
